export  const config={
   // url:'http://localhost:9147'
  url:'https://api.staybistro.de'
 }
 export const headersinfo={
     'Access-Control-Allow-Origin':'*',
     'Content-Type': `multipart/form-data`,
 }